import axios from 'axios';
import { myShopApiStore } from '../Stores';

axios.interceptors.response.use(
    response => {
        if (!myShopApiStore.isOnline) {
            myShopApiStore.isOnline = true;
            
            window.dispatchEvent(new Event('online'));
        }
        return response;
    },
    error => {
        if (!navigator.onLine || error.message === 'Network Error') {
            myShopApiStore.isOnline = false;
            window.dispatchEvent(new Event('offline'));
        }
        return Promise.reject(error);
    }
);